import { Drawer } from 'antd';

import BaseLoader from '../base-loader';

import type { FC, PropsWithChildren } from 'react';

interface BaseDrawerProps extends PropsWithChildren {
  open: boolean;
  onClose: () => void;
  zIndex?: number;
  width?: number | string;
  closable?: boolean;
  maskClosable?: boolean;
  loading?: boolean;
}

const BaseDrawer: FC<BaseDrawerProps> = ({
  open,
  onClose,
  children,
  zIndex = 1100,
  width = 460,
  closable = false,
  maskClosable = false,
  loading,
}) => {
  return (
    <Drawer
      closable={closable}
      maskClosable={maskClosable}
      width={width}
      zIndex={zIndex}
      open={open}
      onClose={onClose}
      styles={{
        body: { padding: 0 },
        mask: { backgroundColor: 'rgba(102, 113, 128, 0.3)' },
      }}
    >
      {loading ? (
        <BaseLoader loading style={{ height: '100%', display: 'flex' }} />
      ) : (
        children
      )}
    </Drawer>
  );
};
export default BaseDrawer;
